import {
  setBudgetState,
  initDynamicTableData,
  setCurrentNavPage,
  setDynamicTableFilterYear,
  setSubMenuDirection,
  setSubMenuDirectionToggle,
  updateDynamicTableData,
  initCollaboratorsSynthesis,
  initBudgetSettingClient,
  setBudgetSettingClient,
  setBudgetStateConfig,
  setFilterCollaborators,
  setStartPageState,
  setDynamicTableCollaboratorRole
} from "Actions";
import classNames from "classnames";
import { HORIZONTAL, PAGES, VERTICAL } from "Config";
import _ from "i18n";
import React, { useEffect, useState, useRef } from "react";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import {
  fetchDynamicTableData,
  updateBudgetParts,
  fetchDynamicTableCollaborators,
  exportPeriodFinancialSheet,
  fetchCollaboratorSuggestions
} from "Thunks";
import {
  getBudgetaryBenchmark,
  getBudgetaryBenchmarkRate,
  getBudgetaryBenchmarkRatio,
  generateBudgetStatus
} from "Utils";
import { ICONS } from "../Common/Icons";
import PageHeader from "../Common/PageHeader/PageHeader";
import BudgetStateFilter from "./BudgetStateFilter/BudgetStateFilter";
import styles from "./DynamicTable.local.scss";
import DynamicTableFilter from "./DynamicTableFilter";
import ReactTable from "./ReactTable/ReactTable";
import { push } from "react-router-redux";
import { Skeleton } from "antd";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { BUDGET_STATE_CONFIG } from "Config";
import clonedeep from "lodash.clonedeep";
import moment from "moment";
import { inIframe } from "../../utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";

const DynamicTable = props => {
  const [data, setData] = useState([]);
  const [pageIndexPagination, setPageIndexPagination] = useState(0);
  const [skipPageReset, setSkipPageReset] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [selectedLimit, setSelectedLimit] = useState(5);
  const [startPage, setStartPage] = useState(5);
  const filterFormState = useState(false);
  const setFilterFormIsVisible = filterFormState[1];
  const {
    dispatch,
    subMenuDirection,
    fetching,
    fetched,
    error,
    budgetState,
    dataSource,
    lengthData,
    dataTotal,
    collaborators,
    collaboratorsFetching,
    collaboratorsFetched,
    budgetStateConfig,
    selectedYear
  } = props;

  useEffect(() => {
    let year = moment().year();
    dispatch(setCurrentNavPage(PAGES.FINANCIAL_SHEET_PAGE));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }

    dispatch(setBudgetStateConfig(BUDGET_STATE_CONFIG));

    dispatch(setBudgetState([BUDGET_STATE_CONFIG[0].id]));

    dispatch(setSubMenuDirectionToggle(false));

    dispatch(setDynamicTableFilterYear(year + "/" + year));

    if (!fetched) {
      return () => {
        dispatch(initDynamicTableData());
        dispatch(initCollaboratorsSynthesis());
      };
    }
  }, []);

  useEffect(
    () => {
      if (!fetching) {
        dispatch(fetchDynamicTableData());
      }
    },
    [budgetState, selectedYear, startPage, pageSize]
  );
  const dataSourceRef = useRef(dataSource);

  useEffect(
    () => {
      dataSourceRef.current = dataSource;
    },
    [dataSource]
  );

  useEffect(
    () => {
      setData([...dataSourceRef.current]);
      let budgetStateConfigClone = clonedeep(BUDGET_STATE_CONFIG);
      budgetStateConfigClone = budgetStateConfigClone.map(item => {
        const budgetStatus = generateBudgetStatus(item["id"]);
        // console.log("budgetStatus==");
        // console.log("===", budgetStatus);
        return {
          ...item,
          count: dataSource.filter(element =>
            budgetStatus.includes(element["hourlyBudgetStatus"])
          ).length
        };
      });
      dispatch(setBudgetStateConfig(budgetStateConfigClone));
    },
    [dataSource]
  );

  useEffect(
    () => {
      setSkipPageReset(false);
    },
    [data]
  );

  const handleStateChange = selected => {
    dispatch(setBudgetState(selected));
  };

  const synchronizeData = ({ rowIndex, property, value }) => {
    setSkipPageReset(true);
    // setData(old => {
    //   return old.map((item, index) => {
    //     if (index === rowIndex) {
    //       let newBudgetaryBenchmarkRatio;
    //       let newBudgetaryBenchmark;
    //       let newBudgetaryBenchmarkRate;
    //       switch (property) {
    //         case "budget":
    //           newBudgetaryBenchmarkRatio = getBudgetaryBenchmarkRatio(
    //             Number(old[index]["economic"]["value"]),
    //             value
    //           );
    //           break;
    //         case "economic":
    //           newBudgetaryBenchmarkRatio = getBudgetaryBenchmarkRatio(
    //             value,
    //             Number(old[index]["budget"]["total"])
    //           );
    //           break;
    //         default:
    //           break;
    //       }
    //       newBudgetaryBenchmark = getBudgetaryBenchmark(
    //         newBudgetaryBenchmarkRatio
    //       );
    //       newBudgetaryBenchmarkRate = getBudgetaryBenchmarkRate(
    //         newBudgetaryBenchmark
    //       );

    //       const { economic, budgetaryBenchmark } = item;
    //       return {
    //         ...item,
    //         economic: {
    //           ...economic,
    //           budgetaryBenchmarkRatio: newBudgetaryBenchmarkRatio
    //         },
    //         budgetaryBenchmark: {
    //           ...budgetaryBenchmark,
    //           ratio: newBudgetaryBenchmark,
    //           rate: newBudgetaryBenchmarkRate
    //         }
    //       };
    //     }
    //     return item;
    //   });
    // });
  };

  const handleSelectedCollaborator = value => {
    let collaborator = [];
    console.loh("handleSelectedCollaborator debut");
    dispatch(fetchCollaboratorSuggestions(value)).then(res => {
      res.value.data.data.map(t => {
        if (value === t.id) {
          collaborator = [
            {
              value: t.id,
              label: t.name,
              color: "#000000"
            }
          ];
        }
      });
      console.loh("handleSelectedCollaborator debut");
      dispatch(setFilterCollaborators(collaborator));
      dispatch(setDynamicTableCollaboratorRole([]));
      dispatch(fetchDynamicTableData());
    });
  };

  const updateData = ({ rowIndex, property, value }) => {
    setSkipPageReset(true);
    // setData(old => {
    //   const budget = { ...old[rowIndex], [property]: value };
    //   let totalEconomic;
    //   let totalH = 0;
    //   let newBudgetaryBenchmarkRatio;
    //   let newBudgetaryBenchmark;
    //   let newBudgetaryBenchmarkRate;
    //   let totalBudget;

    //   switch (property) {
    //     // case "budget":
    //     //   budget["budget"]["subTotals"].map((item, index) => {
    //     //     totalBudget = Number(
    //     //       Number(old[0]["budget"]["subTotals"][index]["value"]) -
    //     //         Number(old[rowIndex]["budget"]["subTotals"][index]["value"]) +
    //     //         Number(budget["budget"]["subTotals"][index]["value"])
    //     //     );
    //     //     old[0]["budget"]["subTotals"][index]["value"] = totalBudget;
    //     //     totalH += totalBudget;
    //     //   });
    //     //   old[0]["budget"]["total"] = totalH;
    //     //   newBudgetaryBenchmarkRatio = getBudgetaryBenchmarkRatio(
    //     //     Number(old[0]["economic"]["value"]),
    //     //     totalH
    //     //   );
    //     //   old[0]["economic"][
    //     //     "budgetaryBenchmarkRatio"
    //     //   ] = newBudgetaryBenchmarkRatio;
    //     //   break;
    //     case "economic":
    //       totalEconomic = Number(
    //         Number(old[0]["economic"]["value"]) -
    //           Number(old[rowIndex]["economic"]["value"]) +
    //           Number(budget["economic"]["value"])
    //       );
    //       old[0]["economic"]["value"] = Number(totalEconomic.toFixed(2));

    //       newBudgetaryBenchmarkRatio = getBudgetaryBenchmarkRatio(
    //         totalEconomic,
    //         old[0]["budget"]["total"]
    //       );
    //       old[0]["economic"][
    //         "budgetaryBenchmarkRatio"
    //       ] = newBudgetaryBenchmarkRatio;
    //       newBudgetaryBenchmark = getBudgetaryBenchmark(
    //         newBudgetaryBenchmarkRatio
    //       );
    //       newBudgetaryBenchmarkRate = getBudgetaryBenchmarkRate(
    //         newBudgetaryBenchmark
    //       );
    //       old[0]["budgetaryBenchmark"]["rate"] = newBudgetaryBenchmarkRate;
    //       old[0]["budgetaryBenchmark"]["ratio"] = newBudgetaryBenchmark;
    //       break;
    //     default:
    //       break;
    //   }
    //   dispatch(updateBudgetParts(budget)).then(res => {
    //     dispatch(updateDynamicTableData(rowIndex, budget));
    //     NotificationManager.success(_("update"), _("updateSuccessful"));
    //   });
    //   return old;
    // });
  };

  const handleFetchCollaborators = () => {
    if (!collaboratorsFetched && !collaboratorsFetching) {
      dispatch(fetchDynamicTableCollaborators());
    }
  };

  const renderRipple = () => {
    return (
      <div className={styles.ripple_loading}>
        <img src={"/img/Ripple-1s-150px.svg"} alt="" />
      </div>
    );
  };

  const renderFilter = () => {
    return (
      <DynamicTableFilter
        filterFormIsVisible={handleFilterFormIsVisible}
        pageSize={pageSize}
        handleDynamicTablePageSize={setPageSize}
      />
    );
  };

  const handleRedirectBudgetSetting = ({ id, name, year }) => {
    dispatch(initBudgetSettingClient());
    dispatch(setBudgetSettingClient({ id, name }));
    dispatch(push(`/budget-setting/?name=${name}&id=${id}&year=${year}`));
  };

  const handleFilterFormIsVisible = isVisible => {
    setFilterFormIsVisible(isVisible);
  };

  const handleChangeStartPage = start => {
    setStartPage(start);
    dispatch(setStartPageState(start));
  };

  let renderExportDynamicTable = () => {
    const { fetched, exportFetching } = props;

    if (fetched) {
      return (
        <div
          className="row medium-6"
          style={{
            marginTop: "2%",
            marginRight: "-21%"
          }}
        >
          <div
            className={"medium-3"}
            style={{
              marginLeft: "24%"
            }}
          >
            <a
              target="_blank"
              className="btn secondary text-uppercase"
              onClick={handleExportFinancialSheet}
            >
              {exportFetching ? (
                <img
                  width={"16%"}
                  src={"/img/icons/tail-spin-blue.svg"}
                  alt={""}
                />
              ) : (
                <img
                  width={"11%"}
                  src={"/img/icons/exportation.svg"}
                  alt={""}
                />
              )}
              {_("Export")}
            </a>
          </div>
        </div>
      );
    }

    return "";
  };

  const handleExportFinancialSheet = () => {
    // const { dispatch } = this.props;

    dispatch(exportPeriodFinancialSheet(selectedYear));
  };

  return (
    <div>
      {inIframe() === false && (
        <div style={{ marginBottom: "10px" }}>
          <NotificationBar
            message={_("notifyUsingUa")}
            isUaNotification={true}
            theme="lightOrange"
          />
        </div>
      )}
      <PageHeader
        header={_("dynamic-table")}
        subHeader={_("subTitleDynamicTable")}
        icon={ICONS.FINANCIAL_PAGE_ICON}
        customAddOn={renderExportDynamicTable()}
      />
      <div className={styles.resizable}>
        <div>
          <div className={classNames("ttp-tab-container")}>
            <div className="rmodal__center">
              {renderFilter()}
              {budgetStateConfig && budgetStateConfig.length > 0 ? (
                <BudgetStateFilter
                  majorKey={budgetStateConfig[0].id}
                  configState={budgetStateConfig}
                  selectedState={budgetState}
                  handleStateChange={handleStateChange}
                  collaborators={collaborators}
                  collaboratorsFetching={collaboratorsFetching}
                  collaboratorsFetched={collaboratorsFetched}
                  handleFetchCollaborators={handleFetchCollaborators}
                  handleSelectedCollaborator={handleSelectedCollaborator}
                />
              ) : (
                <Skeleton
                  style={{ width: 200 }}
                  active={true}
                  avatar={false}
                  paragraph={false}
                />
              )}{" "}
              {error && <h1>An error occured</h1>}
              {fetching ? (
                renderRipple()
              ) : fetched && !error ? (
                <ReactTable
                  selectedYear={selectedYear}
                  fetching={fetching}
                  data={data && data.filter(item => item.level !== "level-1")}
                  dataTotal={dataTotal}
                  handleChangeStartPage={handleChangeStartPage}
                  lengthData={lengthData}
                  pageIndexPagination={pageIndexPagination}
                  setPageIndexPagination={setPageIndexPagination}
                  synchronizeData={synchronizeData}
                  updateData={updateData}
                  skipPageReset={skipPageReset}
                  pageSizeProp={pageSize}
                  setPageSize={setPageSize}
                  selectedLimit={selectedLimit}
                  setSelectedLimit={setSelectedLimit}
                  handleRedirectBudgetSetting={handleRedirectBudgetSetting}
                />
              ) : (
                <NotFoundV2
                  errorPageType={"ACCESS_DENIED"}
                  text={_("No data found")}
                  buttonIgnored={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div />
    </div>
  );
};

const mapStateToProps = state => ({
  selectedYear: state.budget.dynamicTable.filter.year,
  budgetState: state.budget.dynamicTable.filter.budgetState,
  budgetStateConfig: state.budget.dynamicTable.filter.budgetStateConfig,
  dataSource: state.budget.dynamicTable.items,
  dataTotal: state.budget.dynamicTable.total,
  lengthData: state.budget.dynamicTable.resultCount,
  fetching: state.budget.dynamicTable.fetching,
  fetched: state.budget.dynamicTable.fetched,
  error: state.budget.dynamicTable.error,
  erpData: state.erpData.data,
  collaboratorsFetching: state.budget.dynamicTable.collaborators.fetching,
  collaboratorsFetched: state.budget.dynamicTable.collaborators.fetched,
  collaboratorsError: state.budget.dynamicTable.collaborators.error,
  collaborators: state.budget.dynamicTable.collaborators.items,
  exportFetching: state.financialSheet.exportFinancialSheet.fetching
});

export default connect(mapStateToProps)(DynamicTable);



// WEBPACK FOOTER //
// ./src/components/DynamicTable/DynamicTable.js